/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createAdditionalQuestionDataTypeSchema = z.enum(['select', 'text', 'open_text', 'datetime', 'file'])

export type CreateAdditionalQuestionDataTypeSchema = z.infer<typeof createAdditionalQuestionDataTypeSchema>
